import { Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import DocumentViewer from './pages/DocumentViewer';
import Admin from './pages/Admin';
import AdminFolder from './pages/AdminFolder';
import SharedDataset from './pages/SharedDataset';
import Navbar from './components/Navbar';
import ProtectedRoute from './routes/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen">
        <Navbar />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/:documentId"
            element={
              <ProtectedRoute>
                <DocumentViewer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/folders/:uid/:folderId"
            element={
              <ProtectedRoute>
                <AdminFolder />
              </ProtectedRoute>
            }
          />
          {/* Public: datasets shared with other companies */}
          <Route path="/share/:token" element={<SharedDataset />} />
        </Routes>
      </div>
    </AuthProvider>
  );
}

export default App;